module.exports = __webpack_public_path__ + "static/media/run_path_screenshot.ab058bb7.png";